<script>
	import Button from '$lib/Components/Layout/Button/Button.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
</script>

<Section backgroundColor="grey-blue" id="form">
	<h2 class="text-left">Let's Solve Your Window Challenge</h2>
	<p class="text-left">
		Whether you're looking to reduce noise, meet energy codes, or avoid costly
		replacements, Indow can help you plan a solution that works.
	</p>

	<Button href="/about-indow/commercial-sales" color="blue-grey-light"
		>Request a Consultation</Button
	>
</Section>
